// extracted by mini-css-extract-plugin
module.exports = {"articleContent":"ArticleContent_articleContent__0Vwp7"};